module.exports = __webpack_public_path__ + "e49b349956533b73b899e4e5032932d7.svg";